import * as React from 'react';
import { Popover, Text, Box } from 'wix-style-react';
import { TruncatedText, TruncatedTextProps } from '../TruncatedText';

export interface TruncatedTextTooltipProps extends TruncatedTextProps {
  dataHook: string;
  maxTextLength?: number;
}

export const TruncatedTextWrapper = (props: TruncatedTextTooltipProps) => {
  const [isTooltipDisplayed, setIsTooltipDisplayed] = React.useState<boolean>(
    false,
  );
  const { dataHook, text, maxWidth, maxTextLength, ...textProps } = props;

  return text.length > maxTextLength! ? (
    <Popover
      theme='light'
      placement='top'
      showArrow='true'
      shown={isTooltipDisplayed}
      appendTo='window'
      moveBy={{ x: 0, y: 3 }}
    >
      <Popover.Element>
        <div
          onMouseOver={() => setIsTooltipDisplayed(true)}
          onMouseLeave={() => setIsTooltipDisplayed(false)}
        >
          <TruncatedText
            {...textProps}
            dataHook={dataHook}
            text={text}
            maxWidth={maxWidth}
          />
        </div>
      </Popover.Element>
      <Popover.Content>
        <Box padding='5px 14px'>
          <Text>{text}</Text>
        </Box>
      </Popover.Content>
    </Popover>
  ) : (
    <Text {...textProps.componentProps} dataHook={dataHook}>
      {text}
    </Text>
  );
};
